import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Member leaves a library',
  name: 'leave_library',
  params: [
    {
      description: 'The id of the library',
      name: 'library_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The id of the library member that left',
      name: 'library_member_id',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
